
























import ArticleInfoBaseTemplate from '../info/ArticleInfoBaseTemplate';
import ArticleInfoCover from '@root/views/article/components/video/ArticleInfoCover.vue';
import getStreamElement from '@root/modules/article/utils/getStreamElement';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoCover,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html
        ? this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '')
        : this.$props.article.content.title.text;
    },
    showViews() {
      return this.$channelConfig('settings').showViews ?? false;
    },
    streamElement() {
      return getStreamElement(this.article);
    },
  },
});
